"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DLOCAL_REGEX = exports.DLOCAL_MOBILE_PAYMENT_METHODS = exports.DLOCAL_COUNTRIES = void 0;
exports.DLOCAL_COUNTRIES = [
    'argentina',
    'bangladesh',
    'bolivia-plurinational-state-of',
    'brazil',
    'chile',
    'colombia',
    'costa-rica',
    'ecuador',
    'egypt',
    'india',
    'kenya',
    'mexico',
    'morocco',
    'nigeria',
    'panama',
    'paraguay',
    'peru',
    'philippines',
    'turkey',
    'uruguay',
];
exports.DLOCAL_MOBILE_PAYMENT_METHODS = [
    'daviplata',
    'etisalat-cash',
    'gcash',
    'maya',
    'mercado-pago:argentina',
    'nequi:colombia',
    'vodafone-cash:egypt',
    'mpesa:kenya',
];
exports.DLOCAL_REGEX = new RegExp([
    '^airtm:(bank:(',
    exports.DLOCAL_COUNTRIES.join('|'),
    ')|mobile:(',
    exports.DLOCAL_MOBILE_PAYMENT_METHODS.join('|'),
    '))',
].join(''));
